import React from "react";
import PropTypes from "prop-types";
import "../../VehiculeForm.css";
import { vehiculeDataPropType } from "../../../../types/vehiculeTypes";

const DisplaySignatureNeuf = ({ vehiculeData, readOnly = false }) => {
  return (
    <div className="form-section">
      <div className="section">
        <h3>SIGNATURES</h3>
        
        {/* Signature du titulaire */}
        <div className="form-group">
          <label>SIGNATURE DU TITULAIRE</label>
          <div className="form-group">
            <label>FAIT À:</label>
            <input
              type="text"
              value={vehiculeData.sig_1 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>LE:</label>
            <div className="date-input-group">
              <div className="date-field">
                <label>JOUR</label>
                <input
                  type="text"
                  value={vehiculeData.sig_1_1 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                  placeholder="JJ"
                />
              </div>
              <div className="date-field">
                <label>MOIS</label>
                <input
                  type="text"
                  value={vehiculeData.sig_1_2 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                  placeholder="MM"
                />
              </div>
              <div className="date-field">
                <label>ANNÉE</label>
                <input
                  type="text"
                  value={vehiculeData.sig_1_3 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                  placeholder="AAAA"
                />
              </div>
            </div>
          </div>

          <div className="checkbox-group">
            <input
              type="checkbox"
              checked={vehiculeData.sig_1_5 === "1"}
              readOnly={readOnly}
              disabled={readOnly}
            />
            <label>
              JE SUIS INFORMÉ(E) QUE POUR CIRCULER AVEC CE VEHICULE JE SUIS DANS L&apos;OBLIGATION DE L&apos;ASSURER PRÉALABLEMENT (ARTICLES L.324-1 ET L.324-2 DU CODE DE LA ROUTE).
            </label>
          </div>
          <div className="checkbox-group">
            <input
              type="checkbox"
              checked={vehiculeData.sig_1_4 === "1"}
              readOnly={readOnly}
              disabled={readOnly}
            />
            <label>
              JE M&apos;OPPOSE À LA RÉUTILISATION DE MES DONNÉES PERSONNELLES À DES FINS DE PROSPECTION COMMERCIALE
            </label>
          </div>
        </div>

        {/* Signature du loueur */}
        <div className="form-group">
          <label>SIGNATURE DU LOUEUR</label>
          <div className="form-group">
            <label>FAIT À:</label>
            <input
              type="text"
              value={vehiculeData.sig_2 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>LE:</label>
            <div className="date-input-group">
              <div className="date-field">
                <label>JOUR</label>
                <input
                  type="text"
                  value={vehiculeData.sig_2_1 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                  placeholder="JJ"
                />
              </div>
              <div className="date-field">
                <label>MOIS</label>
                <input
                  type="text"
                  value={vehiculeData.sig_2_2 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                  placeholder="MM"
                />
              </div>
              <div className="date-field">
                <label>ANNÉE</label>
                <input
                  type="text"
                  value={vehiculeData.sig_2_3 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                  placeholder="AAAA"
                />
              </div>
            </div>
          </div>

          <div className="checkbox-group">
            <input
              type="checkbox"
              checked={vehiculeData.sig_2_4 === "1"}
              readOnly={readOnly}
              disabled={readOnly}
            />
            <label>
              JE M&apos;OPPOSE À LA RÉUTILISATION DE MES DONNÉES PERSONNELLES À DES FINS DE PROSPECTION COMMERCIALE
            </label>
          </div>
        </div>

        {/* Signature du locataire */}
        <div className="form-group">
          <label>SIGNATURE DU LOCATAIRE</label>
          <div className="form-group">
            <label>FAIT À:</label>
            <input
              type="text"
              value={vehiculeData.sig_3 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>LE:</label>
            <div className="date-input-group">
              <div className="date-field">
                <label>JOUR</label>
                <input
                  type="text"
                  value={vehiculeData.sig_3_1 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                  placeholder="JJ"
                />
              </div>
              <div className="date-field">
                <label>MOIS</label>
                <input
                  type="text"
                  value={vehiculeData.sig_3_2 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                  placeholder="MM"
                />
              </div>
              <div className="date-field">
                <label>ANNÉE</label>
                <input
                  type="text"
                  value={vehiculeData.sig_3_3 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                  placeholder="AAAA"
                />
              </div>
            </div>
          </div>

          <div className="checkbox-group">
            <input
              type="checkbox"
              checked={vehiculeData.sig_3_4 === "1"}
              readOnly={readOnly}
              disabled={readOnly}
            />
            <label>
              JE M&apos;OPPOSE À LA RÉUTILISATION DE MES DONNÉES PERSONNELLES À DES FINS DE PROSPECTION COMMERCIALE
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

DisplaySignatureNeuf.propTypes = {
  vehiculeData: vehiculeDataPropType.isRequired,
  readOnly: PropTypes.bool
};

export default DisplaySignatureNeuf; 